/**
 * Dashboard Translations Module (Spanish)
 * Matches English structure exactly
 * @module dashboard
 * @language es
 */

export const dashboard = {
  index: {
    heroTitle: "Observatorio de Futuros de los Consejos de Desarrollo JCI",
    heroSubtitle: "Midiendo Liderazgo Joven, Salud Mental y Oportunidad Económica Globalmente",
    heroDescription: "Una plataforma impulsada por datos que analiza las condiciones para jóvenes líderes en 114 países. Usando métricas verificadas de la red global de JCI y asociaciones de investigación.",
    globalImpactTitle: "Impacto Global de un Vistazo",
    verifiedData: "Datos verificados del Informe de Impacto JCI 2025",
    globalMembers: "Miembros Globales",
    activeWorldwide: "Activos mundialmente",
    projects: "Proyectos",
    period20242025: "Período: 2024-2025",
    volunteerHours: "Horas de Voluntariado",
    hoursContributed: "Horas contribuidas",
    countries: "Países",
    worldwidePresence: "Presencia mundial",
    localOrganizations: "Organizaciones Locales",
    activeCommunities: "Comunidades activas",
    digitalReachTitle: "Alcance y Huella Digital",
    totalFollowers: "Seguidores Totales",
    jciccUsers: "Usuarios jci.cc",
    memberDemographicsTitle: "Instantánea de Demografía de Miembros",
    averageAge: "Edad Promedio",
    yearsOld: "Años",
    universityEducated: "Educación Universitaria",
    bachelorsOrHigher: "Licenciatura o superior",
    fullTime: "Tiempo completo",
    entrepreneurs: "Emprendedores",
    employmentStatus: "Estado de Empleo"
  },
  charts: {
    noDataAvailable: "Datos no disponibles",
    dataLoadingSoon: "Los datos se cargarán pronto",
    noFunnelData: "Datos de embudo no disponibles",
    configureProcessData: "Configure los datos del proceso",
    radarUnavailable: "Datos de radar no disponibles",
    configurePerformanceIndicators: "Configure indicadores de rendimiento",
    performanceUnavailable: "Datos de rendimiento no disponibles",
    configureTrendData: "Configure datos de tendencia",
    currentProgress: "Progreso Actual",
    goal2040: "Meta 2040",
    mainValue: "Valor Principal",
    trend: "Tendencia",
    goal: "Meta"
  },
  header: {
    title: "Observatorio de Futuros de la Juventud de los Consejos de Desarrollo JCI",
    subtitle: "Observatorio Global de los Consejos de Desarrollo",
    tagline: "Desarrollando Líderes para un Mundo Cambiante"
  },
  dashboard: {
    heroTitle: "Observatorio de Futuros de la Juventud de los Consejos de Desarrollo JCI",
    heroSubtitle: "Midiendo Liderazgo Joven, Salud Mental y Oportunidad Económica",
    heroDescription: "Comprendiendo la oportunidad global de los jóvenes a través del Índice de Futuros de la Juventud (YFI)",
    learnAboutFII: "Conozca más sobre el YFI",
    globalReach: "Alcance Global",
    activeMembersWorldwide: "Miembros Activos Mundialmente",
    acrossCountries: "En 114 Países",
    localOrganizations: "Organizaciones Locales",
    impactDelivered: "Impacto Entregado",
    beneficiariesReached: "Beneficiarios Alcanzados (2024-2025)",
    projectsImplemented: "Proyectos Implementados",
    volunteerHours: "Horas de Voluntariado Contribuidas",
    digitalPresence: "Presencia Digital",
    socialFollowers: "Seguidores en Redes Sociales",
    monthlyImpressions: "Impresiones Mensuales",
    magazineReaders: "Lectores de Revista (70+ países)",
    websiteEngagement: "Engagement del Sitio Web",
    activeUsers: "Usuarios Activos en jci.cc",
    pageViews: "Vistas de Página",
    avgSessionDuration: "Duración Promedio de Sesión",
    whatIsFII: "¿Qué es el Índice de Futuros de la Juventud (YFI)?",
    fiiDescription: "El YFI mide la oportunidad de los jóvenes en 114 países usando tres dimensiones ponderadas",
    mentalHealth: "Salud Mental",
    mentalHealthDesc: "Prevalencia de salud mental, tasas de suicidio, acceso a servicios",
    workforcePreparation: "Preparación Laboral",
    workforceDesc: "Desempleo juvenil, desarrollo de habilidades, logro educativo",
    entrepreneurship: "Emprendimiento",
    entrepreneurshipDesc: "Ambiente de negocios, apoyo al emprendimiento, innovación",
    exploreFullIndex: "Explorar el Índice Completo",
    memberExperience: "Instantánea de Experiencia del Miembro",
    basedOnSurvey: "Basado en Encuesta de Miembros (2025)",
    keyDemographics: "Demografía Clave",
    averageAge: "Edad Promedio",
    years: "años",
    genderDistribution: "Distribución de Género",
    male: "Masculino",
    female: "Femenino",
    other: "Otro",
    employmentStatus: "Estado de Empleo",
    fullTimeEmployed: "Empleado a Tiempo Completo",
    entrepreneurSelfEmployed: "Emprendedor/Autónomo",
    student: "Estudiante",
    education: "Educación",
    universityDegrees: "Títulos Universitarios",
    regionalAgeRange: "Rango de Edad Regional",
    youngest: "Más Joven",
    oldest: "Más Viejo",
    membershipTenure: "Antigüedad de Membresía",
    newMembersJoining: "Nuevos miembros uniéndose",
    buildingFoundation: "Construyendo base",
    growingLeadership: "Creciendo liderazgo",
    experiencedMembers: "Miembros experimentados",
    sustainedCommitment: "Compromiso sostenido",
    projectsAcrossRegions: "proyectos en 4 regiones",
    demographicsMotivations: "Demografía y motivaciones",
    mentalHealthIndex: "Índice de Salud Mental",
    fiiWeight: "del YFI • Datos globales de crisis",
    fiiRankingsAnalysis: "Índice y análisis del YFI",
    digitalReach: "Tendencias digitales e innovación",
    howFIICalculated: "Cómo se calcula el YFI",
    conferencesPrograms: "Conferencias y programas de JCI",
    strategicGrowthTargets: "Metas estratégicas de crecimiento",
    regionalCouncils: "AMDEC, ADC, APDC, EDC",
    howToContribute: "Cómo contribuir",
    frequentlyAskedQuestions: "Preguntas frecuentes"
  },
  metrics: {
    membersActive: "Miembros Activos",
    countriesPresent: "Países Presentes",
    startupsSupported: "Startups Apoyadas",
    sustainableProjects: "Proyectos Sostenibles",
    completed: "completado",
    countries: "Países",
    members: "Miembros",
    projects: "Proyectos",
    projectsPerYear: "Proyectos/año",
    memberDensity: "Densidad de Miembros",
    country: "País",
    regionalDistribution: "Distribución Regional",
    globalPresence: "Presencia global de JCI en 2025",
    activeMembers: "Miembros Activos",
    globally: "globalmente",
    worldwidePresence: "presencia mundial",
    communities: "Comunidades",
    activeCommunities: "comunidades activas",
    yearsOfHistory: "Años de Historia",
    since1915: "desde 1915",
    vs2024: "vs 2024",
    annualProjects: "Proyectos Anuales",
    in2025: "en 2025"
  },
  dashboardTenure: {
    lessThan1Year: "<1 año",
    years1to3: "1-3 años",
    years4to6: "4-6 años",
    years7to9: "7-9 años",
    moreThan10Years: ">10 años",
    respondents: "encuestados"
  },
  homeGlobalPresence: {
    title: "Presencia Global JCI",
    subtitle: "Activos en 114 Países en 4 Regiones",
    regions: "Regiones",
    countries: "Países",
    members: "Miembros",
    localOrgs: "Orgs Locales"
  },
  globalPresenceMap: {
    title: "Presencia Global JCI",
    subtitle: "Activos en 114 Países en 4 Regiones",
    countriesLabel: "países",
    regionsLabel: "regiones",
    countriesCount: "Países",
    membersCount: "Miembros",
    localOrgs: "Organizaciones Locales",
    regions: {
      asiaPacific: "Asia y el Pacífico",
      europe: "Europa",
      africaMe: "África y Oriente Medio",
      americas: "América"
    }
  },
  observatoryHeader: {
    title: "Observatorio de Futuros JCI",
    subtitle: "Observatorio Global de los Consejos de Desarrollo",
    tagline: "Desarrollando Líderes para un Mundo Cambiante",
    members: "Miembros",
    countries: "Países",
    beneficiaries: "Beneficiarios",
    projects: "Proyectos"
  },
  homeGlobalMap: {
    title: "Presencia Global JCI",
    subtitle: "Jóvenes líderes activos en 114 países",
    members: "Miembros",
    countries: "Países",
    localOrgs: "Orgs Locales",
    click: "Clic para detalles"
  },
  jciGlobalPresence: {
    title: "Presencia Global JCI",
    subtitle: "Activos en 114 Países en 4 Regiones",
    countries: "países",
    orgs: "orgs",
    regions: "regiones",
    africaMiddleEast: "África y Oriente Medio",
    americas: "América",
    asiaPacific: "Asia y el Pacífico",
    europe: "Europa"
  },
  chartsAdvanced: {
    loading: "Cargando gráfico...",
    noData: "Datos no disponibles",
    error: "Error al cargar gráfico",
    xAxis: "Eje X",
    yAxis: "Eje Y",
    legend: "Leyenda",
    tooltip: "Tooltip",
    zoom: "Zoom",
    pan: "Mover",
    reset: "Restablecer",
    download: "Descargar"
  },
  digitalEcosystem: {
    title: "Ecosistema Digital JCI",
    subtitle: "Plataformas digitales impulsando el engagement y alcance de los miembros",
    website: "Sitio Web",
    socialMedia: "Redes Sociales",
    magazine: "Revista",
    activeUsers: "Usuarios Activos",
    followers: "Seguidores",
    readers: "Lectores",
    engagement: "Engagement",
    reach: "Alcance",
    impressions: "Impresiones"
  },
  observatoryMastery: {
    title: "Maestría del Observatorio",
    modulesExplored: "Módulos Explorados",
    outOf: "de",
    observer: "Observador",
    analyst: "Analista",
    visionary: "Visionario",
    keepExploring: "¡Sigue explorando para desbloquear insights!",
    almostThere: "¡Casi llegas! Te estás convirtiendo en un experto.",
    masterAchieved: "¡Has dominado el Observatorio!",
    unlockReward: "Visita todos los módulos para desbloquear el Resumen Ejecutivo",
    loginToTrack: "Inicia sesión para seguir tu progreso de exploración en los 14 módulos",
    signInToStart: "Iniciar sesión"
  },
  apiAnalytics: {
    title: "Análisis de API",
    description: "Monitorea el uso, rendimiento y tendencias de la API",
    last24Hours: "Últimas 24 Horas",
    last7Days: "Últimos 7 Días",
    last30Days: "Últimos 30 Días",
    totalRequests: "Total de Solicitudes",
    successful: "exitosas",
    avgResponseTime: "Tiempo de Respuesta Promedio",
    acrossAllEndpoints: "En todos los endpoints",
    errorRate: "Tasa de Error",
    errors: "errores",
    activeApiKeys: "Claves de API Activas",
    totalKeys: "claves totales",
    requestsOverTime: "Solicitudes a lo Largo del Tiempo",
    requestsByDay: "Solicitudes de API por día",
    requestsByEndpoint: "Solicitudes por Endpoint",
    distributionAcrossEndpoints: "Distribución entre endpoints de API",
    responseStatusCodes: "Códigos de Estado de Respuesta",
    distributionOfStatusCodes: "Distribución de códigos de estado HTTP",
    topApiKeys: "Principales Claves de API",
    keysWithHighestUsage: "Claves con mayor uso",
    active: "Activa",
    inactive: "Inactiva",
    noApiKeysFound: "No se encontraron claves de API"
  }
} as const;
